import type { ModeColor } from "@src/types/factory-dashboard";
import type { DrBoyMachineOverviewDefinition } from "@src/types/factory-dashboard-dr-boy";

const GREY: ModeColor = {
  outline: "rgb(138, 143, 152)",
  background: "rgba(138, 143, 152, 0.1)",
};
const YELLOW: ModeColor = {
  outline: "rgb(245, 179, 1)",
  background: "rgba(245, 179, 1, 0.1)",
};
const GREEN: ModeColor = {
  outline: "rgb(32, 178, 107)",
  background: "rgba(32, 178, 107, 0.1)",
};

export const modeMapping = {
  0: { label: "modules.machineOverviewContainer.mode.other", color: GREY },
  1: { label: "modules.machineOverviewContainer.mode.automatic", color: GREEN },
  2: {
    label: "modules.machineOverviewContainer.mode.semiAutomatic",
    color: GREEN,
  },
  3: { label: "modules.machineOverviewContainer.mode.manual", color: YELLOW },
  4: { label: "modules.machineOverviewContainer.mode.setup", color: YELLOW },
  5: {
    label: "modules.machineOverviewContainer.mode.sleep",
    color: GREY,
  },
};

export const machinesDrBoy: DrBoyMachineOverviewDefinition[] = [
  {
    sourceId: "a0d62c7b-02b8-82b8-8cf3-848b9503c402",
    nodes: {
      machineMode: "ns=6;i=6031",
      job: "ns=6;i=6038",
      nominalParts: "ns=6;i=6040",
      jobGoodPartsCounter: "ns=6;i=6049",
      cycleTime: "ns=6;i=6053",
      jobBadPartsCounter: "ns=6;i=6047",
    },
    modeMapping,
  },
  {
    sourceId: "d8ed167b-ac10-8c10-b01e-0fa6bd4e2902",
    nodes: {
      machineMode: "ns=6;i=6031",
      job: "ns=6;i=6038",
      nominalParts: "ns=6;i=6040",
      jobGoodPartsCounter: "ns=6;i=6049",
      cycleTime: "ns=6;i=6053",
      jobBadPartsCounter: "ns=6;i=6047",
    },
    modeMapping,
  },
  {
    sourceId: "98b655a2-0fb1-8fb1-a1d2-1a2d8c398d02",
    nodes: {
      machineMode: "ns=6;i=6031",
      job: "ns=6;i=6038",
      nominalParts: "ns=6;i=6040",
      jobGoodPartsCounter: "ns=6;i=6049",
      cycleTime: "ns=6;i=6053",
      jobBadPartsCounter: "ns=6;i=6047",
    },
    modeMapping,
  },
  {
    sourceId: "8553a910-c505-8505-a7e2-b030f4b2cc02",
    nodes: {
      machineMode: "ns=6;i=6031",
      job: "ns=6;i=6038",
      nominalParts: "ns=6;i=6040",
      jobGoodPartsCounter: "ns=6;i=6049",
      cycleTime: "ns=6;i=6053",
      jobBadPartsCounter: "ns=6;i=6047",
    },
    modeMapping,
  },
];
